export default {
      id: "ic-para-thumbup-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-thumbup-usage",
      toString: function () {
        return this.url;
      }
    }